import { setHoveredUnitId } from '@/features/project/projectSlice';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import type { ColorScaleOptions } from '../BuildingVisualizers';

import {
  CustomReport,
  CustomReportTabContent,
} from '../CustomReportTabContent';

import { report3 } from '../demoCSVData';

export function VacancyReportTabContent() {
  const dispatch = useDispatch();

  const [selectedScale, setSelectedScale] =
    useState<ColorScaleOptions>('default');

  const report: CustomReport = {
    name: 'Vacancy Report',
    data: report3,
    columns: [
      {
        label: 'Status',
        kind: 'string',
        sortable: true,
        showCheckbox: true,
        className: 'text-left',
      },
      {
        label: 'Unit',
        kind: 'string',
        sortable: true,
        showCheckbox: true,
        className: 'text-left',
      },
      {
        label: 'Type',
        kind: 'string',
        sortable: true,
        showCheckbox: true,
        className: 'text-left',
      },
      {
        label: 'Renovated',
        sortable: true,
        showCheckbox: true,
        className: 'text-left',
      },
      {
        label: 'Pre-Leased',
        sortable: true,
        showCheckbox: true,
        className: 'text-left',
        kind: 'string',
      },
      {
        label: 'Vacancy Days',
        kind: 'number',
        sortable: true,
        showCheckbox: true,
        className: 'text-left',
      },
    ],
  };

  return (
    <>
      {/* <div className="flex flex-row gap-4">
        <button onClick={() => setReport(rentroll)}>Rent Roll</button>
        <button onClick={() => setReport(aggregated)}>Upcoming Week</button>
      </div> */}
      <div className="flex w-full flex-col gap-4">
        <div className="flex-0 flex flex-row justify-start gap-4" />
        <div className="flex-grow">
          <CustomReportTabContent
            report={report}
            onHoverUnit={(unitId) => {
              dispatch(setHoveredUnitId(unitId));
            }}
            hoveredUnitId={null}
            onSelectUnit={(unit) => {}}
            colorScale={selectedScale}
          />
        </div>
      </div>
    </>
  );
}
